import CountUp from "react-countup";
import React, {useEffect, useState} from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  RoundsNBlackout,
  InfoMain,
  InfoDiv,
  ButtonRequest,
  InputAddIndustry,
  UserDiv,
  ListPlayers
} from "./styles";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from "react-dom/cjs/react-dom.development";



const SetupIndustry = () => {

  const [nameInsumo, setNameInsumo] = useState('')
  const [showLista, setShowLista] = useState(false)
  const [insumos, setInsumos] = useState([])
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [idInsumo, setIdInsumo] = useState(0)
  const [listaPlayers, setListaPlayers] = useState(null)
  const [produtoCusto, setProdutoCusto] = useState(null)
  const [produtoPreco, setProdutoPreco] = useState(null)
  const [produtoPerda, setProdutoPerda] = useState(null)
  const [estoqueInicial, setEstoqueInicial] = useState('')
  const [produtoUnidade, setProdutoUnidade] = useState('')

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  function handleAddIndustry() {
    const data = {
      industria: 0,
      nome: nameInsumo
    }

    api.post("/api/insumo/cadastrar", data)
      .then(response => console.log(response))

    setShowInputToAddIndustry(false)
  }

  function listAllInsumos(insumo) {

    if(insumo.insumo !== idInsumo) {
      setProdutoCusto('')
      setProdutoPerda('')
      setEstoqueInicial('')
      setProdutoUnidade('')
      setProdutoPreco('')
      setShowLista(!showLista)
    }

    setIdInsumo(insumo.insumo)

    try {
      api.get("/api/insumo/listarTodos")
      .then(response => setInsumos(response.data))
    } catch(error) {
      console.log(error)
    }

    setShowLista(!showLista)

   
  }

  function addNewProduct(insumo) {
    const data = {
        "estoque": estoqueInicial ? estoqueInicial : insumo.estoque,
        "nome": insumo.nome,
        "urlImagem": "",
        "insumo": insumo.insumo
      }

    api.post("/api/insumo/cadastrar", data)
      .then(response => console.log(response))

     

    setProdutoCusto('')
    setProdutoPerda('')
    setEstoqueInicial('')
    setProdutoUnidade('')
    setProdutoPreco('')

    setShowInputToAddIndustry(false)
  }

  useEffect(() => {

    try {
      api.get("/api/insumo/listarTodos")
      .then(response => setInsumos(response.data))
    } catch(error) {
      console.log(error)
    }
    

   
  }, [api])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Insumos" />
        <BackButton path="/menuIndustry" />
        <Title>
          Número de Insumos <span>{insumos?.length}</span>
        </Title>
        <MainContainer>

          {insumos?.map((insumo, k) => {
            return (
            <div key={k}>
              <ButtonsDiv  >
                <ButtonCompanies onClick={() => listAllInsumos(insumo)}>{insumo.nome}</ButtonCompanies>
       
              </ButtonsDiv>
              {
                showLista && insumo.insumo === idInsumo ? (
              
                
                  <UserDiv>

                  <InfoMain>
                 
                    <InfoDiv>
                      <p>Estoque Inicial:</p>
                      <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={estoqueInicial} onChange={(e) => setEstoqueInicial(e.target.value)} placeholder={insumo.estoque < 0 || !insumo.estoque ? 0 : insumo.estoque + " kg"} type="number" /></ButtonCompanies>
                
                    </InfoDiv>

                    <div style={{display: "flex", width: "100%", justifyContent: "center"}}>
                      <ButtonCompanies style={{color: "orange", background: "#fff"}} onClick={() => addNewProduct(insumo)} >Atualizar Insumo</ButtonCompanies>
                    </div>
                    
                  </InfoMain>

                 


               
                  </UserDiv>
              
                
                ) : (<></>)
              }
      
            </div>
            )
          })}
          
          {

            showInputToAddIndustry &&
              <ButtonsDiv>
                <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry name={nameInsumo} onChange={e => setNameInsumo(e.target.value)} placeholder="Nome do insumo" type="text" /></ButtonCompanies>
                <ButtonDeleteCompanies onClick={() => handleAddIndustry()} >&#9989;</ButtonDeleteCompanies>
              </ButtonsDiv>

          }
         
          <TitlePages text="Setup Insumos" />
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default SetupIndustry;
